const initProductSelection = () => {
    // clickable element
    const tabButtons = document.querySelectorAll('[data-toggler]');
    // element that change on click
    const productForms = document.querySelectorAll('[data-toggled]');
    // form active right after the load of the page and its id
    const selectedForm = document.querySelector('.showcase-product.is-visible');
    const activeId = selectedForm.id;
    if (selectedForm) {
        calcPrice();
        initPriceCalculations();
    }
    const showForm = (formElement) => {
        formElement.classList.remove("not-visible");
        formElement.classList.add("is-visible");
        calcPrice();
        initPriceCalculations();
    };
    const hideAllForms = (arrayForms) => {
        arrayForms.forEach(function (singleForm) {
            singleForm.classList.remove("is-visible");
            singleForm.classList.add("not-visible");
        });
    };
    const removeSelected = (arrayElements) => {
        arrayElements.forEach(function (element) {
            element.classList.remove("selected");
        });
    };
    //Select the current tab active; onclick Switch tab and show the corespondent form and calc the price and put it in the html.
    tabButtons.forEach(function (singleButton) {
        if (singleButton.getAttribute('data-toggler') === activeId) {
            singleButton.classList.add("selected");
        }
        singleButton.addEventListener('click', function () {
            hideAllForms(productForms);
            removeSelected(tabButtons);
            singleButton.classList.add("selected");
            productForms.forEach(function (singleForm) {
                if (singleButton.getAttribute('data-toggler') === singleForm.getAttribute('data-toggled')) {
                    showForm(singleForm);
                }
            });
        });
    });
};
